import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { Button } from 'semantic-ui-react'
import { Card, CardContent } from 'components/Card'
import { CustomerModal } from 'components/CustomerModal'
import { Loader } from 'shared/components/Loader'
import styled from 'styled-components'
import useModal from 'hooks/useModal'
import { useParams } from 'react-router-dom'
import { getSurveyTypeFromId } from 'reducers'
import { useSelector } from 'react-redux'

const CardWrapper = styled.div`
  & .ui.card .content {
    padding: 1em 1em;
  }
`
export function CustomerListWidget({
  loading,
  customers,
  audienceRules,
  downloadAudienceRulesCSV,
  isDownloading,
}) {
  const { Modal, open, close } = useModal()
  const { surveyId } = useParams()
  const surveyType = useSurveyType()

  function useSurveyType() {
    return useSelector((state) => getSurveyTypeFromId(state, surveyId))
  }

  function _onClicked(event) {
    event.preventDefault()
    open()
  }

  if (loading) {
    return (
      <CardWrapper>
        <Card style={{ minHeight: '150px' }}>
          <Loader />
        </Card>
      </CardWrapper>
    )
  }

  if (customers && customers.number_of_customer > 0) {
    const header = `${customers.number_of_customer.toLocaleString()} customers match this survey's rules`
    let description = `Once you set the survey live, we'll send it to them and new users that start to match these rules.`

    if (surveyType == 'web_embed') {
      description = `Once the survey is set to live, it will be visible to any current or future customers who meet these defined rules.`
    }
    return (
      <CardWrapper>
        <Card style={{ minHeight: '150px', minWidth: '320px' }}>
          <React.Fragment>
            <CardContent header={header} description={description} />
            <Button.Group
              attached="bottom"
              basic
              widths="2"
              style={{ border: 0, borderTop: '1px solid rgba(34,36,38,.15)' }}
            >
              <Button onClick={_onClicked}>
                <i className="fas fa-eye icon" style={{ marginBottom: '6px' }} />
                <br />
                View matching
              </Button>
              <Button
                onClick={downloadAudienceRulesCSV}
                disabled={isDownloading}
                loading={isDownloading}
              >
                <i className="far fa-arrow-to-bottom" style={{ marginBottom: '6px' }} />
                <br />
                Download CSV
              </Button>
            </Button.Group>
            <CustomerModal
              Modal={Modal}
              header={header}
              handleCloseModal={close}
              customerList={customers.customers}
              downloadAudienceRulesCSV={downloadAudienceRulesCSV}
              isDownloading={isDownloading}
            />
          </React.Fragment>
        </Card>
      </CardWrapper>
    )
  }

  if (R.isEmpty(audienceRules)) {
    return (
      <CardWrapper>
        <Card>
          <CardContent
            header="No rules added yet"
            description="Add a rule to specify who should get this survey."
          />
        </Card>
      </CardWrapper>
    )
  }

  return (
    <CardWrapper>
      <Card style={{ minHeight: '150px' }}>
        <CardContent
          header="No customers match these rules yet"
          description="But if you set the survey live, it will be sent to those who match your rules in the future."
        />
      </Card>
    </CardWrapper>
  )
}

CustomerListWidget.propTypes = {
  loading: PropTypes.bool,
  customers: PropTypes.object,
  audienceRules: PropTypes.array,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/CustomerListWidget/container.js